var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-special-coin",class:[("tag-special-coin--" + _vm.variant)]},[_vm._t("default",[_c('p',[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }